module.exports = __webpack_public_path__ + "img/WE_d2.176ca714.png";